function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  // var elements = getFocusableElements(container);
  // var first = elements[0];
  // var last = elements[elements.length - 1];
if(typeof last == "undefined") return;
  
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input_mainvalues = this.input.value;    
    this.span_rs = this.querySelector(".rs_popup_hidden_span") || null;
    if (this.span_rs) {
      this.minData = parseInt(this.span_rs.dataset.min);      
    }

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();    
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {    
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.input_mainvalues = this.input.value;
    
    this.main_man = this.closest('[metawise-variant-rs-coanvo-main]') || null;

     const card =  this.input.closest('.grid__item');
         const main_button = card?.querySelector("[data-custom-input-conf]");
         const handle = main_button?.getAttribute("data-var-handle"); 
         const parent_section = main_button?.closest(".selected_product_data") || null;
          const pre_selected_product_slot = parent_section?.querySelector(`[data-slot-first-data='${handle}']`) || null;

          
    if(this.main_man && document.body.classList.contains('template-scadas-rs') && !pre_selected_product_slot){
          document.querySelectorAll(".metawise-selected_rs .grid__item.selected_card").forEach(el => el.classList.remove("selected_card"));
          card.classList.add("selected_card");
          rs_popuup_open();
          return null;
    }



    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }


    
   const target_fun = event.target.closest('metawise-variant-selector') || null;
    //   if(target_fun){
    //         const test_inner =  event.target.closest('.product-card')?.querySelector('.selected_product_tag')?.innerHTML || null;
    //         console.log("test_inner != null",test_inner != null);
    //         if(test_inner != null){
    //             target_fun.handleSelection(event.target);
    //             }
    //       }


    // consfrgation stap 8 eventmobilr

    // if(this.input.closest('configure-form') && !this.closest(".fourth_step")){
    //   onchecang_iteams(this.input);
    // }

     if(this.input.closest('configure-form')){
      this.its_pluse = true;      
      if(this.input_mainvalues > this.input.value ){
        this.its_pluse = false;
      }      
      this.difreans = this.input.value - this.input_mainvalues
      if(this.difreans < 0) this.difreans = 0;        

           onchecang_iteams(this.input,this.its_pluse,this.difreans,event);
      
      this.input_mainvalues = this.input.value      
    }

  }

  validateQtyRules(input_vals = null) {
    let value = parseInt(this.input.value);
    if(input_vals){
       value = parseInt(input_vals.value);
    }
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");      
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));    
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }  
    if(this.span_rs != null){      
      if(this.minData == 7)
      {
        if(value < 2 ){          
          this.span_rs.innerHTML = 0;  
        }else{          
          this.span_rs.innerHTML = value - 2;
        }
      }else{
         if(value < 1 ){          
            this.span_rs.innerHTML = 0;  
          }else{          
            this.span_rs.innerHTML = value - 1;
          }
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      if(target.getAttribute('data-montage_checkbox') == 'true' || target.getAttribute('data-montage_checkbox')) return;
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          const sliderOptions = this.getAttribute('data-slider-options');
            if (sliderOptions){
               const slideroptionConfig = JSON.parse(sliderOptions),
               recommedndationSlider = new Swiper(".recom-swiper", slideroptionConfig);
            } 
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// sart custom code

class DrawerClose extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a') || null;
    if(!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    this.closest('details').querySelector('summary').click();
  }
}

 // <drawer-close>
 //   <a href="javascript:void(0);"class="close-icon" id="mobile_menu_click">text</a>
 // </drawer-close>

customElements.define('drawer-close', DrawerClose);

// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }
 
  connectedCallback() {
    this.init();
    // Watch for DOM changes inside this component
    const observer = new MutationObserver(() => {
      this.init();
    });
    observer.observe(this, { childList: true, subtree: true });    
  }

  init() {
    // this.updateHiddenInput();
    this.setupFirstCheckboxListener();
    this.setupSecondCheckboxListener();
    this.removeSecondCheckboxValue();
    this.setupThirdCheckboxListener();
    this.setupRadioListeners();
    this.checkQtyButtonState();
  }

  updateHiddenInput() {
    const thirdCheckbox = this.querySelector('.third-meta-val');
    const selectedRadio = this.querySelector('.product-card .variant-radio:checked');
    if (thirdCheckbox?.checked && selectedRadio) {
      thirdCheckbox.value = selectedRadio.value;
    } else if (thirdCheckbox) {
      thirdCheckbox.value = '';
    }
  }

  qtyButtonDisble() {
    const plusQty = document.querySelectorAll(".selected_product_data.active .plus_qty_product");
    plusQty?.forEach(qty => {
      const parent = qty.closest("quantity-input");
      parent.querySelector(".quantity_product_card").value = 1;
      qty.classList.add("disabled");
      qty.style.pointerEvents = "none";
    });
  }

  qtyButtonEnable() {
    const plusQty = document.querySelectorAll(".selected_product_data.active .plus_qty_product");
    plusQty.forEach(qty => {
      qty.classList.remove("disabled");
      qty.style.pointerEvents = "initial";
    });
  }

  checkQtyButtonState() {
    const firstInput = this.querySelector('.first-meta-val');
    const secondInput = this.querySelector('.seond-meta-val');
    const thirdInput = this.querySelector('.third-meta-val');
    const allChecked = firstInput?.checked && secondInput?.checked && thirdInput?.checked;

    if (allChecked) {
      this.qtyButtonDisble();  // disable if 3 already selected
    } else {
      this.qtyButtonEnable();  // otherwise enable
    }
  }

  setupThirdCheckboxListener() {
    const selected_product = this.querySelector('.select_third_product');
    const thirdCheckbox = this.querySelector('.third-meta-val');
    const thirdTitle = this.querySelector('.third_pro_title');
    
    if (!thirdCheckbox) return;

    thirdCheckbox.addEventListener('change', () => {
      if (thirdCheckbox.checked) {
        thirdCheckbox.classList.add("checkboxchecked");
        selected_product?.classList.add("hidden");
        selected_product?.classList.remove("active");
      } else {
        this.querySelector(".thirdMeta")?.classList.remove("thirdMeta");
        thirdCheckbox.classList.remove("checkboxchecked");       
        selected_product?.classList.add("active");
        selected_product?.classList.remove("hidden");
        thirdTitle.innerHTML = "";
      }
      const parent_div = thirdCheckbox.closest("[data-third-meta]");
      thirdCheckbox.removeAttribute("checked");
      thirdCheckbox.value = "";
      parent_div.setAttribute("data-third-meta", "");
      parent_div.setAttribute("data-third-meta-handle","")

      // this.updateHiddenInput();
      selected_product_tag();
      this.checkQtyButtonState();
    });
  }

  setupSecondCheckboxListener() {
    const isSecondChecked = this.querySelector(".seond-meta-val");
    if (isSecondChecked) {
      isSecondChecked.addEventListener('change', () => {
        if (!isSecondChecked.checked) {
          this.querySelector(".thirdMeta")?.classList.remove("thirdMeta");
        }
        
        const parent_div = isSecondChecked.closest("[data-second-meta]");
        const product_title = parent_div.querySelector(".second_pro_title");
        product_title.innerHTML = "";
        isSecondChecked.removeAttribute("checked");
        isSecondChecked.checked = false;
        isSecondChecked.value = "";
        parent_div.setAttribute("data-second-meta", "");
        parent_div.setAttribute("data-second-meta-handle","")
        selected_product_tag();
        this.checkQtyButtonState();
      });
    }
  }

  setupFirstCheckboxListener() {
    const isFirstChecked = this.querySelector(".first-meta-val");
    if (isFirstChecked) {
      isFirstChecked.addEventListener('change', () => {
        if (!isFirstChecked.checked) {
          this.querySelector(".thirdMeta")?.classList.remove("thirdMeta");
        }
        const parent_div = isFirstChecked.closest("[data-first-meta]");
        const product_title = parent_div.querySelector(".first_pro_title");
        product_title.innerHTML = "";
        isFirstChecked.removeAttribute("checked");
        isFirstChecked.checked = false;
        isFirstChecked.value = "";
        parent_div.setAttribute("data-first-meta", "");
        parent_div.setAttribute("data-first-meta-handle", "");
        selected_product_tag();
        this.checkQtyButtonState();
      });
    }
  }

  removeSecondCheckboxValue() {
    const remove_button = this.querySelector(".remove-second-btn");
    remove_button?.addEventListener('click', () => {
      const parent_div = remove_button.closest("[data-second-meta]");
      const second_input = parent_div?.querySelector(".seond-meta-val");
      const product_title = parent_div?.querySelector(".second_pro_title");
      product_title.innerHTML = "";
      second_input.removeAttribute("checked");
      second_input.checked = false;
      second_input.value = "";
      parent_div.setAttribute("data-second-meta", "");
      parent_div.setAttribute("data-second-meta-handle","")
      selected_product_tag();
      this.checkQtyButtonState();
    });
  }

  setLocalstorageqty(handle,quantity){
    let stored = [];
    stored.push({ handle: handle,quantity: quantity});
    localStorage.setItem("selectedProducts", JSON.stringify(stored));
  }

  setupRadioListeners() {
    const radios = this.querySelectorAll('.product-card .variant-radio');
    const firstInput = this.querySelector('.first-meta-val');
    const secondInput = this.querySelector('.seond-meta-val');
    const secoundMetaDiv = this.querySelector('[data-second-meta]');
    const thirdInput = this.querySelector('.third-meta-val');
    const selected_product = this.querySelector('.select_third_product');
  
    const firstTitle = this.querySelector('.first_pro_title');
    const secondTitle = this.querySelector('.second_pro_title');
    const thirdTitle = this.querySelector('.third_pro_title');
  
    if (!radios.length) return;
  
    const setSlot = (input, titleEl, varianthandle, variantId, productTitle, metaDiv = null) => {
      if (!input) return;
      input.value = "";
      input.value = variantId;  
      
      input.checked = true;
      if (titleEl) titleEl.innerHTML = productTitle;
      if (metaDiv) metaDiv.setAttribute("data-second-meta", variantId);
      if (input.classList.contains("first-meta-val")) {
        const parent = input.closest("[data-first-meta]");
        if (parent) parent.setAttribute("data-first-meta", variantId);
      }   
      if(input.classList.contains("third-meta-val"))  {
        const parent_third = input.closest("[data-third-meta]");
         input.value = variantId;    
        if (parent_third){
          parent_third.setAttribute("data-third-meta", variantId);
        } 
      }

      const parent_handle = input.closest("[data-second-meta-handle], [data-third-meta-handle], [data-first-meta-handle]");      
      if (parent_handle) {
        parent_handle.setAttribute("data-first-meta-handle", varianthandle);
        parent_handle.setAttribute("data-second-meta-handle", varianthandle);
        parent_handle.setAttribute("data-third-meta-handle", varianthandle);
      }
    };
  
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        is_selected_any_product(radio);
        const variantId = radio.value;
        const varianthandle = radio.getAttribute("data-var-handle");
        const productTitle = radio.getAttribute("data-product-title");
  
        const mainCart = radio.closest('.product-card');
        const qtyElement = mainCart.querySelector(".quantity_product_card");
        const qty = parseInt(qtyElement?.value || "1");
  
        const isFirstChecked = firstInput?.checked;
        const isSecondChecked = secondInput?.checked;
        const isThirdChecked = thirdInput?.checked;
        // -----------------
        // Rule: always fill next empty slot in order
        // -----------------
  
        if (qty >= 3) {
          // Fill all empty slots
          if (!isFirstChecked) setSlot(firstInput, firstTitle, varianthandle, variantId, productTitle);
          if (!isSecondChecked) setSlot(secondInput, secondTitle, varianthandle, variantId, productTitle, secoundMetaDiv);
          if (!isThirdChecked) setSlot(thirdInput, thirdTitle, varianthandle, variantId, productTitle);
          this.setLocalstorageqty(varianthandle,qty);
          selected_product?.classList.add("hidden");
          
        }
        else if (qty === 2) {
          // Fill 2 empty slots in order
          let filled = 0;
          if (!isFirstChecked && filled < 2) {
            setSlot(firstInput, firstTitle, varianthandle, variantId, productTitle);
            filled++;
            this.setLocalstorageqty(varianthandle,qty);
          }
          if (!isSecondChecked && filled < 2) {
            setSlot(secondInput, secondTitle, varianthandle, variantId, productTitle, secoundMetaDiv);
            filled++;
            this.setLocalstorageqty(varianthandle,qty);
          }
          if (!isThirdChecked && filled < 2) {
            setSlot(thirdInput, thirdTitle, varianthandle, variantId, productTitle);
            filled++;
            this.setLocalstorageqty(varianthandle,qty);
          }
          if (filled > 0) selected_product?.classList.add("hidden");
        }
        else {
          // qty = 1 → fill first empty slot only
          if (!isFirstChecked) {
            setSlot(firstInput, firstTitle, varianthandle,  variantId, productTitle);
          } else if (!isSecondChecked) {
            setSlot(secondInput, secondTitle, varianthandle, variantId, productTitle, secoundMetaDiv);
          } else if (!isThirdChecked) {
            setSlot(thirdInput, thirdTitle, varianthandle, variantId, productTitle);            
            selected_product?.classList.add("hidden");
          }         
        }       
  
        selected_product_tag();
        radio.checked = false;
        this.checkQtyButtonState();
      });
    });
  }

}
if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector);
}


class PreviousBtn extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initPreviousBtn();
  }

  initPreviousBtn() {
      this.addEventListener('click', () => {
        const currentStep = this.closest('.cust-form-wrapp');       
        if (currentStep) {      
          const is_conditional = this.classList.contains("conditional_previous");
          if (is_conditional) {
          const conditional_btn = this.classList.add("conditional_previous");
          }
          const conditional_btn = this.classList.contains("conditional_previous");
          if(conditional_btn){
            const parent = this.closest(".credit_step_one");
            if (!parent) return;
            const allAccordions = parent.querySelectorAll(".collapse-accordian-block.main_acc_credit");
            allAccordions.forEach(acc => {
              acc.classList.remove("hidden");
            });
            const subContents = parent.querySelectorAll(".collapse-accordian-block.show_hidden_content");
            subContents.forEach(subContent => {
              subContent.classList.add("hidden"); 
            })
            this.classList.remove("conditional_previous")
            const next_btn = parent.querySelector("next-btn");            
            next_btn.classList.add("show_same_block_con");            
          }else{
            const prevStep = currentStep.previousElementSibling;
              if (prevStep && prevStep.classList.contains('cust-form-wrapp')) {
                currentStep.style.display = 'none';
                prevStep.style.display = 'block';
              }
          }
        }
      });
  }
}
customElements.define('previous-btn', PreviousBtn);

class NextBtn extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  customAddToCart(product, openDrawer) {  
    fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(product)
    })
    .then(response => {    
      if (!response.ok) {throw new Error('Network response was not ok');}
    })
    .then(response => {
      console.log("Response:", response);
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      document.querySelector('cart-drawer')?.refresh(true);    
    });
  }

  handleClick(event) {
    let it_s_canvas_stap = "";
    if(!document.body.classList.contains("template-anovis-configuration-plan")){
       it_s_canvas_stap =  this.closest('[id^="shopify-block-"].fourth_step')?.querySelector('canvas#customizer-canvas') || null;      
    }else{
       it_s_canvas_stap =  this.closest('[id^="shopify-block-"].fifth_step')?.querySelector('canvas#customizer-canvas') || null;      
    }   
   
   if(it_s_canvas_stap) canvasimagecheck();

    

    // add to cart product
    const conditional_btn = this.classList.contains("show_same_block_con");
    const atc_btn = this.classList.contains("next_button_with_atc");
    if(atc_btn){      
      // statoc_radio_atc(this);
      const currentStep = this.closest('.cust-form-wrapp');
      if (!currentStep) return;      
      const checked = [...currentStep.querySelectorAll(".is_product_in_atc:checked")];
      const unchecked = [...currentStep.querySelectorAll(".is_product_in_atc:not(:checked)")];
      
      const unactive = unchecked.flatMap(el => {
        const name = el.getAttribute("name") || "";
        return (el.getAttribute("pre-selecetd-handle") || "")
          .split(",")
          .filter(Boolean)
          .map(handle => ({ handle, name }));
      });
      
      // build current valid pairs from UI
      const active = checked.flatMap(el => {
        const name = el.getAttribute("name") || "";
        console.log("name..",name);
        return (el.getAttribute("pre-selecetd-handle") || "")
          .split(",")
          .filter(Boolean)
          .map(handle => ({ handle, name }));
      });
      let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
      // remove unchecked
      stored = stored.filter(item =>!unactive.some(a => a.handle === item.handle && a.name === item.name));
      // add new checked
      active.forEach(a => {
        if (!stored.some(s => s.handle === a.handle && s.name === a.name)) {
          stored.push({ ...a, quantity: 1 });
        }
      });      
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
      localStorage.setItem("resultProduct", JSON.stringify(stored));              

      
      // same page redirect
      const next_button_same_page = this.classList.contains("same_page_redirect_result");        
      if(!next_button_same_page){
        let nextStep = currentStep.nextElementSibling;
        while (nextStep && !nextStep.classList.contains('cust-form-wrapp')) {
          nextStep = nextStep.nextElementSibling;
        }
  
        if (!nextStep) return;
        currentStep.style.display = 'none';
        nextStep.style.display = 'block';
        nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }     
      
    } else if (conditional_btn) {    
      const parent = this.closest(".credit_step_one");
      if (!parent) return;            

      const allAccordions = document.querySelectorAll(".collapse-accordian-block.main_acc_credit");
      allAccordions.forEach(acc => {
        acc.classList.add("hidden");
      });
      
      const subContents = parent.querySelectorAll(".show_hidden_content");
      if (!subContents.length) return;
      
      const checkedAccordions = Array.from(allAccordions).filter(acc => {
        const checkbox = acc.querySelector(".summary_credit_input");
        return checkbox?.checked;
      });
      
      subContents.forEach(subContent => {
        const subInputVal = subContent.dataset.headingAcc;
        subContent.classList.add("hidden"); 
      
        const matchFound = checkedAccordions.some(acc => {
          const accordionInputVal = acc.getAttribute("data-heading-acc");
          return subInputVal === accordionInputVal;
        });
      
        if (matchFound) {
          const no_input = subContent.querySelector(".no_input_accordion")?.innerHTML;
          const sub_acc = subContent.querySelectorAll(".content_nested_acc .summary_credit_input");
          console.log(sub_acc.length);  // Checked inputs ni count

          const checkedInputs = Array.from(sub_acc).filter(input => input.checked);
          console.log(checkedInputs.length);  // Checked inputs ni count

          console.log("sub_acc",sub_acc);
          subContent.classList.remove("hidden"); 
        }
      });

      this.classList.remove("show_same_block_con")
      const previous_btn = parent.querySelector("previous-btn");            
      previous_btn.classList.add("conditional_previous");  
      const currentStep = this.closest('.cust-form-wrapp');
      if (!currentStep) return;
      currentStep.scrollIntoView({ behavior: 'smooth', block: 'start' });

    } else {
      const currentStep = this.closest('.cust-form-wrapp');
      if (!currentStep) return;
      const next_button_result = this.classList.contains("result_data_next_btn");  
      // if(next_button_result){
      //   console.log("next_button_result",next_button_result);                      
      //   // xs result page
      //   // metafield in result data set
      //   const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
      //   const accordian_info = JSON.parse(localStorage.getItem("accordian_info") || "[]");
      //   const credit_accordion = JSON.parse(localStorage.getItem("credit_accordion") || "[]");
      //   const show_image_main = JSON.parse(localStorage.getItem("show_image_main") || "[]");
      //   const fifth_accordian_info = JSON.parse(localStorage.getItem("fifth_accordian_info") || "[]");
      //   const seventh_tab_info = JSON.parse(localStorage.getItem("seventh_tab_info") || "[]");
      //   const ZipFile = JSON.parse(localStorage.getItem("ZipFile") || "[]"); 
      //   const form_data = JSON.parse(localStorage.getItem("form_data") || "[]"); 
      //   const timeElapsed = Date.now();
      //   const today = new Date(timeElapsed);
      //   const date_formate = today.toLocaleDateString().replaceAll("/", ".");;
      //   const body = document.body;                
         
      //     // if(document.body.classList.contains("customer-logged-in")){
      //       if (body.classList.contains("template-scadas-xs")) {                 
      //         const existingData = {};              
      //         existingData[`Testsystem-result-${date_formate}`] =  {
      //             selectedProducts,
      //             accordian_info,
      //             credit_accordion,
      //             show_image_main,
      //             fifth_accordian_info,
      //             seventh_tab_info,
      //             ZipFile,
      //             form_data
      //           }
      //           window.finalData = existingData || {};
      //            console.log("window.finalData",window.finalData);   
             
      //       }else if (body.classList.contains("template-result-scadas-testsystem")) {
      //         const existingData = {};
      //           existingData[`Testsystem-result-${date_formate}`] = {
      //             selectedProducts,
      //             accordian_info,
      //             credit_accordion,
      //             show_image_main,
      //             fifth_accordian_info,
      //             seventh_tab_info,
      //             ZipFile,
      //             form_data
      //           }            
      //           window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData); 
      //       }else if(body.classList.contains("template-scadas-mobile-lab-rec")){
      //         const existingData = {};
      //         existingData [`Mobile-result-${date_formate}`] = {               
      //             selectedProducts,
      //             accordian_info,
      //             credit_accordion,
      //             show_image_main,
      //             fifth_accordian_info,
      //             seventh_tab_info,
      //             ZipFile,
      //             form_data
      //           }        
      //         window.finalData = existingData || {};   
      //       }else if(body.classList.contains("template-t3ster")){
      //         const existingData = {};
      //         existingData [`t3ster-result-${date_formate}`] = {               
      //             selectedProducts,
      //             accordian_info,
      //             credit_accordion,
      //             show_image_main,
      //             fifth_accordian_info,
      //             seventh_tab_info,
      //             ZipFile,
      //             form_data
      //         }        
      //         window.finalData = existingData || {};   
      //       } else if(body.classList.contains("template-scadas-rs")){
      //         const existingData = {};
      //         existingData [`Rs-result-${date_formate}`] = {               
      //             selectedProducts,
      //             accordian_info,
      //             credit_accordion,
      //             show_image_main,
      //             fifth_accordian_info,
      //             seventh_tab_info,
      //             ZipFile,
      //             form_data
      //           }        
      //         window.finalData = existingData || {};                 
      //       } else if(body.classList.contains("template-star_ccm")){
      //         const existingData = {};
      //         existingData [`Star_ccm-result-${date_formate}`] = {                 
      //             credit_accordion                 
      //           }
      //         window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData); 
      //       } else if(body.classList.contains("template-amesim")){
      //         const existingData = {};              
      //         existingData [`template-amesim-${date_formate}`] = {                 
      //             credit_accordion                 
      //           }
      //         window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData); 
      //       } else if(body.classList.contains("template-simcenter-3d")){
      //         const existingData = {};
      //         existingData [`template-simcenter-3d-result-${date_formate}`] = {                 
      //             credit_accordion                 
      //           }
      //         window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData); 
      //       }else if(body.classList.contains("template-testlab")){
      //         const existingData = {};
      //         existingData [`template-testlab-result-${date_formate}`] = {                 
      //             credit_accordion                 
      //           }
      //         window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData);                 
      //       }else if(body.classList.contains("template-credit-requirement-assess")){
      //         const existingData = {};
      //         existingData [`template-credit-requirement-${date_formate}`] = {                 
      //             credit_accordion                 
      //           }
      //         window.finalData = existingData || {};
      //           console.log("window.finalData",window.finalData);                 
      //       }           
      //       localStorage.setItem("finalData", JSON.stringify(window.finalData));
      
      //       // removeLocalStorage();
      //       console.log("out side the final Daata",window.finalData);        
      // }

      const next_button_same_page = this.classList.contains("same_page_redirect_result");  
      console.log("next_button_same_page",next_button_same_page);
      if(!next_button_same_page){
        let nextStep = currentStep.nextElementSibling;
        while (nextStep && !nextStep.classList.contains('cust-form-wrapp')) {
          nextStep = nextStep.nextElementSibling;
        }
  
        if (!nextStep) return;
        currentStep.style.display = 'none';
        nextStep.style.display = 'block';
        nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }     
    }
  }
}
customElements.define('next-btn', NextBtn);

class configureForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initconfigureForm();
  }

  nextstep(targetele){   
    const currentStep = targetele.closest('.cust-form-wrapp');    
    if (!currentStep) return;
    let nextStep = currentStep.nextElementSibling;    

    while (nextStep && !nextStep.classList.contains('cust-form-wrapp')) {
      nextStep = nextStep.nextElementSibling;
    }
    if (nextStep) {
      nextStep.style.display = 'block';
      currentStep.style.display = 'none';
        requestAnimationFrame(() => {
          const scrollTop = nextStep.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        });
    }
    const if_sticky_product = targetele.closest(".system-successfull");
    if (if_sticky_product) {
      checkSticky?.(); // safely call if defined
    }
  }
  
  initconfigureForm() {
    const formele = this;    
    const btnclick = formele.querySelectorAll('[next_step_button]');               
    btnclick.forEach(item => {
      const hideandshow = (e) => {
        if (document.body.classList.contains('popup-active')) {
          document.body.classList.remove('popup-active');
        }        
        if(item.classList.contains("accordion-svg")){
          // is_selected_any_product(item);
        }
        const is_true = item.getAttribute("next_step_button") ?? true ;        
        if(is_true == "true" ){
           const targetele = e.target;
          this.nextstep(targetele);   
        }else{
          // const all_sections = formele.querySelectorAll('.selected_product_data.active');
          // all_sections?.forEach( all_section => { 
          //   const card = all_section.querySelector(".tag-wise-tab-wrap .product-card.thirdMeta");
          //   if(card){
          //      const radio_btn = card.querySelector(".variant-radio");
          //      radio_btn.setAttribute("next_step_button",true) 
          //      const targetele = e.target;
          //      this.nextstep(targetele);
          //   }            
          // });
        }
      };
      
      item.addEventListener('click', hideandshow);
      item.addEventListener('change', hideandshow);
    });
  }
}

customElements.define('configure-form', configureForm);


// credit in selecetd value show
class ProductSummaryRenderer {
  constructor({ triggerSelector, containerSelector }) {
    this.triggers = document.querySelectorAll(triggerSelector);
    this.container = document.querySelector(containerSelector);

    if (!this.triggers.length || !this.container) {
      console.warn("ProductSummaryRenderer: Missing trigger(s) or container.");
      return;
    }
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach((btn) => {
      btn.addEventListener("click", () => this.renderSummary());
    });
  }

  renderSummary() {
    const allDetails = document.querySelectorAll(".credit-accordion-plist");
    this.container.innerHTML = "";

    const fragment = document.createDocumentFragment();
    let hasData = false;

    allDetails.forEach((detailsEl) => {
      const parentCheckbox = detailsEl.querySelector('input[name="contact[checkbox_show]"]');
      const heading = parentCheckbox?.dataset.productHeading?.trim();
      const isParentChecked = parentCheckbox?.checked;
// console.log("isParentChecked",isParentChecked,heading)
      if (!isParentChecked || !heading) return;

      const checkedProducts = detailsEl.querySelectorAll("input.contact:checked"); 
// console.log("checkedProducts",checkedProducts,"detailsEl",detailsEl);
      
      if (!checkedProducts.length) return;
      hasData = true;

      const groupEl = document.createElement("div");
      groupEl.className = "product-group";

      const headingEl = document.createElement("h6");
      headingEl.textContent = heading;
      groupEl.appendChild(headingEl);

      const ul = document.createElement("ul");
      checkedProducts.forEach((input) => {
        const title = input.dataset.productTitle?.trim() || "Untitled";
        const li = document.createElement("li");
        li.textContent = title;
        ul.appendChild(li);
      });
      
      groupEl.appendChild(ul);
      fragment.appendChild(groupEl);
    });

    this.container.appendChild(fragment);

    if (!hasData) {
      this.container.textContent = "Keine Produkte ausgewählt.";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ProductSummaryRenderer({
    triggerSelector: ".next-button",
    containerSelector: "#product-summary-container"
  });
});

class VariantSelectsCust extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      window.location.href = target.value;
    });
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
}
customElements.define('variant-selects-cust', VariantSelectsCust);



// filter  js 
class selecetdProductTag extends HTMLElement {
  constructor() {
    super();   
    this.init();
  }

  init() {
    this.selecetdPorductTagText(this);
  }

  async selecetdPorductTagText(current_this) {
    const tabInputs = current_this.querySelectorAll("input.button_tab_inp");
    const variantRadios = current_this.querySelectorAll(".select_product input.variant-radio");

    current_this.querySelectorAll('.cust_show_more_button')?.forEach(button => {
      button.addEventListener("click", () => {    
          const mainDiv = button.closest(".product-card-wrapper");
          if (!mainDiv) return;
    
          const hasThirdMeta = document.querySelector('.thirdMeta') !== null;     
    
          // Choose the correct popup
          const popupElement = mainDiv.querySelector('.popup_data');
          if (popupElement) {
              mainDiv.querySelector(".card_popup_content")?.classList.add("popup-active");
              popupElement.style.display = 'block';
              document.body.classList.add('popup-active');
          }
      });
    });

        // Close both popups from any .close_btn
    current_this.querySelectorAll('.product-card-wrapper .close_btn')?.forEach(closeBtn => {
      closeBtn.addEventListener("click", (event) => {
          event.stopPropagation();
          const mainDiv = closeBtn.closest(".product-card-wrapper");

          // Hide both possible popups
          mainDiv.querySelectorAll(".popup_data, .popup_data_info").forEach(el => {
              el.style.display = 'none';
          });

          mainDiv.querySelectorAll(".card_popup_content").forEach(el => {
              el.classList.remove('popup-active');
          });

          document.body.classList.remove('popup-active');
      });
    });

    function handleSelection(input) {
      const card = input.closest(".grid__item");
      const tab = input.closest(".selecetd_product_tab");
      const details = card?.closest(".pro-card-details");
      const label = card?.querySelector(".selected_product_tag");
      const qtyInput = card?.querySelector(".quantity__input.quantity_product_card");
  
      if (!tab || !card) return;
  
      const isFirst = tab.hasAttribute("data-first-collection");
      const isSecond = tab.hasAttribute("data-second-collection");
  
      const handle = input.dataset.varHandle;
      const name = input.name;
      const labelText = input.dataset.tagText || "";
      const qty = parseInt(qtyInput?.value || "1", 10);    
      
      let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];  
      const index = stored.findIndex(item => item.handle === handle);     
     
      
      if (label && label.innerHTML.trim() === "") {
        is_selected_any_product(input);

        label.innerHTML = labelText;
  
        // Add new data if not already in localStorage
        if (index === -1) {
          stored.push({
            handle,
            name,
            type: isFirst ? "sensor" : isSecond ? "kabel" : "other",
            qty,
          });
        }
  
        // UI Update
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.add("active");
          details?.querySelector(".befor_sensor")?.classList.remove("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.add("active");
          details?.querySelector(".befor_cabel")?.classList.remove("active");
        }
  
        renderSelectedProducts(handle, name);
      } else {
      // If label has value (means already selected → remove)
        isalready_selected_any_product(input);

        if (label) label.innerHTML = "";
  
        if (index !== -1) {
          stored.splice(index, 1);
        }
  
        // UI Reset
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.remove("active");
          details?.querySelector(".befor_sensor")?.classList.add("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.remove("active");
          details?.querySelector(".befor_cabel")?.classList.add("active");
        }
      }
  
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
  
      //  Quantity listener (live update)
      if (qtyInput && !qtyInput.dataset.bound) {
        qtyInput.dataset.bound = "true";
        qtyInput.addEventListener("input", function () {
          const newQty = parseInt(this.value) || 1;
          let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
          const idx = stored.findIndex(item => item.handle === handle);
          if (idx !== -1) {
            stored[idx].qty = newQty;
            localStorage.setItem("selectedProducts", JSON.stringify(stored));
            console.log("Qty updated:", stored[idx]);
          }
        });
      }
    }
  
    tabInputs.forEach(input => {
      input.addEventListener("change", () => handleSelection(input));
    });
  
    variantRadios.forEach(input => {
      input.addEventListener("click", () => handleSelection(input));
    });
  }
  
}

class customfilter extends selecetdProductTag {
  constructor() {
    super();   
    this.init();
  }

  init() {
    this.getInputForEventTarget();
  }

  async getInputForEventTarget(filterParam = null, selectedValue = null) {   
     const filter_data = this.querySelector(".filter-data");   
    if(filter_data){ 
      const collectionInfo = await this.getcollectionInfo(filter_data.dataset.collection);
      if(collectionInfo){
        filter_data.innerHTML = "";

        filter_data.appendChild(collectionInfo); 
        await this.selecetdPorductTagText(this);
        // filter dropdown 
        const filter_dropdown = collectionInfo.querySelectorAll(".filter_main_default");    
        filter_dropdown.forEach((filter) => {
          filter?.addEventListener('click', async (f) => { 
          console.log("filter",filter);
            const dropdowns =  filter.closest(".treatment-filter-grid")?.querySelectorAll("ul.filter-radio-list");                 
            const dropdown = filter.closest("filter-option-select")?.querySelector("ul.filter-radio-list");
            const isActive = dropdown?.classList.contains("active");

            dropdowns?.forEach((d) => d?.classList.remove("active"));

            if (!isActive) {
              dropdown?.classList.add("active");
            }                                        
          });
        });
      }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const is_que = handle.includes('?');
      var params = ""; 
      if(is_que){
        var params = "&";   
      }else{
        var params = "?";  
      }
      const response = await fetch(`${handle}${params}view=filter_data`);
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const filter_data = doc.querySelector(".filter_data_show");
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

}

if (!customElements.get('cust-filter')) {
  customElements.define('cust-filter', customfilter);
}


class filterInoptionSelect extends selecetdProductTag {
  constructor() {
    super();   
    this.init();
  }

  connectedCallback() {}

  init() {
    this.addEventListener('change', async (e) => {
      if (e.target.matches('.selecetd_filter')) {
        const selectedInput = e.target;
        const selectedValue = selectedInput.value;
        // const filterParam = selectedInput.dataset.filterParam; 
        const allSelectedFilters = {};

        const dropdown =  selectedInput.closest("ul.filter-radio-list");         
        dropdown?.classList.remove("active")      

        // Get all selected inputs globally
        this.tab_filter = this.closest(".treatment-filter-grid");
        this.tab_filter.querySelectorAll('.selecetd_filter:checked').forEach(input => {
          const filterParam = input.dataset.filterParam;
          const value = input.value;
          if (filterParam && value) {
            allSelectedFilters[filterParam] = value;
          }
        });
        // if (selectedValue && filterParam) {
          await this.getInputForEventTarget(allSelectedFilters);
        // }
      }
    });
  }

  async getInputForEventTarget(allSelectedFilters) {  
     const filter_data = this.getAttribute("data-collection-url"); 
     const filter_clo_data = this.closest(".filter-data-warpp");
     const product_grid = filter_clo_data.querySelector(".tab-section_product");

     if(!filter_data) return;
       const collectionHandle = filter_data;
      if (!collectionHandle) {
        console.warn('Missing collection handle');
        return;
      }

    let url = `${collectionHandle}?view=filter_data`;
    if(url){
      // Add all selected filters to URL
      Object.entries(allSelectedFilters).forEach(([param, val]) => {
      url += `&${encodeURIComponent(param)}=${encodeURIComponent(val)}`;
    });
      // if (filterParam && selectedValue) {
      //   url += `&${encodeURIComponent(filterParam)}=${encodeURIComponent(selectedValue)}`;
      // }
      // console.log("url",url);
    }
   
    if(filter_data){ 
      const collectionInfo = await this.getcollectionInfo(url);
        if(collectionInfo){
          product_grid.innerHTML = "";
          product_grid.appendChild(collectionInfo)
          const select_filter_tag = this.closest("cust-filter"); 
          await this.selecetdPorductTagText(select_filter_tag);
        }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const response = await fetch(`${handle}`);
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();
      console.log("productHTML",productHTML);

      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const filter_data = doc.querySelector(".cust-product-card-wrapper");
      console.log("filter_data",filter_data);
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
}

if (!customElements.get('filter-option-select')) {
  customElements.define('filter-option-select', filterInoptionSelect);
}



class MetaobjectUpate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initMetaobjectUpate();
  }

  initMetaobjectUpate() {
    const form = this.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      console.log("form..",form);
      e.preventDefault();
      e.stopPropagation();

      try {
        const json = this.buildJSON(form);
        console.log('Payload JSON:', json);

        // 🔹 Await API response
        const json_response = await updatemeta(json);
        console.log('API Response:', json_response);
        // location.reload();
        // 🔹 Optional success handling
        // this.onSuccess(json_response);

      } catch (error) {
        console.error('Metaobject update failed:', error);
        // this.onError(error);
      }
    });
  }

  buildJSON(form) {
    const inputs = form.querySelectorAll('input[name]');
    const result = {};

    inputs.forEach(input => {
      const name = input.name;
      const value = input.value;
      console.log("name....",name);
      // console.log(!name.includes('_ &&_'));
      // if (!name.includes('_ &&_')) return;
      const [objectId, fieldKey] = name.split('_&&_');
      if (!objectId || !fieldKey) return;

      if (!result[objectId]) {
        result[objectId] = {};
      }

      const cleanKey = fieldKey.replace(/^_/, '');
      result[objectId][cleanKey] = value;
    });

    return result;
  }

  onSuccess(response) {
    console.log('Metaobject updated successfully', response);

    // Example:
    // this.dispatchEvent(new CustomEvent('metaobject:updated', { detail: response }));
  }

  onError(error) {
    console.log('Handle error UI here', error);
  }
}

if (!customElements.get('metaobject-upate')) {
  customElements.define('metaobject-upate', MetaobjectUpate);
}
// customElements.define('metaobject_upate', MetaobjectUpate);




class ConfrigatorFilterTogal extends HTMLDivElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.dropdowns =  this.parentElement?.querySelectorAll("ul.filter-radio-list"); 
    this.mainwapper = this.querySelector('ul');
        if(!this.button || !this.button) return;   
        this.button.addEventListener('click', this.onButtonClick.bind(this))
      }

  connectedCallback() {}

  onButtonClick(event) {
    event.preventDefault();
    
                this.dropdowns?.forEach((d) =>
                      d !== this.mainwapper && d?.classList.remove("active")
                    );
                const isActive = this.mainwapper?.classList.contains("active");                        
                if (isActive) {
                  this.mainwapper?.classList.remove("active");
                }else{
                  console.log(this.mainwapper,"click.. remove ");
                  this.mainwapper?.classList.add("active");
                } 
  }
 
}

if (!customElements.get('confrigator-filter')) {
  customElements.define('confrigator-filter', ConfrigatorFilterTogal, { extends: 'div' } );
}


class ConfrigatorFilterdefaultset extends HTMLDivElement {
  constructor() {
    super();
    this.button = this.querySelector('.default_set_value');  
        if(!this.button ) return;   
        this.button.addEventListener('change', this.onButtonClick.bind(this))
      }

  connectedCallback() {}

  onButtonClick(event) {    
    event.preventDefault();
    this.parent = this.closest(".scadas_mobile_filter_wrapp");
    this.key = this.button.getAttribute("data-setmeta-key");
    this.value = this.button.value;
    this.filter_title = this.parent.querySelector(`.filter-option-select[data-set-meta-key='${this.key}']`);    
    this.filter_val = this.filter_title.querySelector(`.selecetd_filter[data-filter-handelize='${this.value}']`) || null;        
     if(this.filter_val == null) return;
        this.filter_val.click();
  } 
}

if (!customElements.get('confrigator-checkbox')) {
  customElements.define('confrigator-checkbox', ConfrigatorFilterdefaultset, { extends: 'div' } );
}


class MainProFilterTogal extends HTMLDivElement {
  constructor() {
    super();
    if(this.dataset.metafildsJsinApi)     this.data = JSON.parse(this.dataset.metafildsJsinApi);    
    this.mainwapper = this.querySelector('[data-product-append-main]');
        if(!this.data || !this.mainwapper) return;   
        // this.filterset();

        this.radios = this.querySelectorAll(".configure-filter input[type=radio]") || null;
          this.radios.forEach((button) =>
            button.addEventListener('change', async (event) => {
              await this.filtersetonchange(event);
            })
        ); 
  }

  connectedCallback() {}

  async filtersetonchange(event){
    console.log("onchnage..",event)
    const grouped = new Map();  
    this.radios.forEach((input) => {
      if (!input.checked) return; 
      const key = input.dataset.filterParam;
      const type = "list";
      const value = input.value.trim();

      if (!key || !value) return;  
      if (!grouped.has(key)) {
        grouped.set(key, { key, type, values: [] });
      }
      grouped.get(key).values.push(value);
    });

    // Build ONLY the "filter" array
    const filter = Array.from(grouped.values()).map((item) => ({
      key: item.key,
      type: item.type,
      value: item.values.join(",")
    }));
    
    this.data.filter = filter;      
    if(!this.data.product_id) this.data = updateMainObject(this.data, this.data.filter);
    this.filterset();
    console.log("filter",filter);
  }

 async filterset(){
  console.log("this.data",this.data);
    const collectionInfo = await load_product_api(this.data);
      SpinnerAdd();    
      await this.productHtmlUpdate(collectionInfo);    
      SpinnerRemove();  
  }

  async productHtmlUpdate(collectionInfo){               
    if (!this.mainwapper) return;
    if(!collectionInfo){
      this.mainwapper.innerHTML = "product not found";  
    }
    
    let items = [];
    // Check Array or Object
      if (Array.isArray(collectionInfo)) {
        items = collectionInfo;     // direct array
      } else if (typeof collectionInfo === "object") {
        items = Object.entries(collectionInfo);                  
      } else {
        console.warn("collectionInfo is neither array nor object");
        return;
      }

      this.mainwapper.innerHTML = "";    
        let index = 0;          
      for (let item of items) {
        let handle;            
        if (Array.isArray(collectionInfo)) {
          handle = item;
        } else {
          handle = item[1];  // object case value
        }
        
        const cardEl = await cardProduct(handle); 
         const inputElements = cardEl?.querySelector('.variant-checkbox.cust_btn_select.is_multi_selected_acc');
        inputElements.type = "radio";   
         inputElements.onchange = null;          // remove JS property
        inputElements.removeAttribute('onchange'); 
        inputElements.setAttribute('onchange', 'Stapthreeredio(this);');
        inputElements.setAttribute('next_step_button', 'true');        

        const inputElements_popup = cardEl.querySelector('.popup_data input.variant-radio');
        inputElements_popup.type = "radio";   
        inputElements_popup.onchange = null;         
        inputElements_popup.removeAttribute('onchange'); 
        inputElements_popup.setAttribute('onchange', 'Stapthreeredio(this);');
        inputElements_popup.setAttribute('next_step_button', 'true');

        cardEl.querySelector(".qty_select_info_wrapp")?.remove();


        if (!cardEl) continue;
        const productId = cardEl.getAttribute("data-product-id");
        const wrapper = document.createElement("div");
        wrapper.className = `grid__item filters-${this.collection_name} `;
        wrapper.id = `filters-${this.collection_name}-${productId}`;
        wrapper.appendChild(cardEl);
        this.mainwapper.appendChild(wrapper);        
        index++; 
      }        
  } 
}

if (!customElements.get('cust-form-filter')) {
  customElements.define('cust-form-filter', MainProFilterTogal, { extends: 'div' } );
}


class tabWithProductFilter extends HTMLDivElement {
  constructor() {
    super();
    if(this.dataset.metafildsJsinApi)     this.data = JSON.parse(this.dataset.metafildsJsinApi);
    this.resetObj =    JSON.parse(this.dataset.metafildsJsinApiReset); 
    this.mainwapper = this.querySelector('[data-product-append-main]');    
        if(!this.data || !this.mainwapper) return;   

        if(this.data?.metafields?.length > 0){
          this.filterset();
        }

        this.radios = this.querySelectorAll("ul.filter-radio-list input[type=checKbox]") || null;        
          this.radios.forEach((button) =>
            button.addEventListener('change', async (event) => {
              await this.filtersetonchange(event);
            })
        ); 
  }

  connectedCallback() {}

  async filtersetonchange(event){
    const grouped = new Map();  
    this.radios.forEach((input) => {
      if (!input.checked) return; 
      const key = input.dataset.filterParam;
      const type = "list";
      const value = input.value.trim();

      if (!key || !value) return;  
      if (!grouped.has(key)) {
        grouped.set(key, { key, type, values: [] });
      }
      grouped.get(key).values.push(value);
    });

    // Build ONLY the "filter" array
    const filter = Array.from(grouped.values()).map((item) => ({
      key: item.key,
      type: item.type,
      value: item.values.join(",")
    }));
    
    this.data.filter = filter;      
    if(!this.data.product_id) this.data = updateMainObject(this.data, this.data.filter);
    this.filterset();
  }

 async filterset(){
    const collectionInfo = await load_product_api(this.data);
      SpinnerAdd();    
      await this.productHtmlUpdate(collectionInfo);    
      SpinnerRemove();  
  }

  async RemoveFilter(){
      const collectionInfo = await load_product_api(this.resetObj);
        SpinnerAdd();    
        await this.productHtmlUpdate(collectionInfo);    
        this.radios.forEach((button) => {
          button.checked = false;
        }); 
        SpinnerRemove();  
    }

  async productHtmlUpdate(collectionInfo){               
    if (!this.mainwapper) return;
    if(!collectionInfo){
      this.mainwapper.innerHTML = "product not found";  
    }
    
    let items = [];
    // Check Array or Object
      if (Array.isArray(collectionInfo)) {
        items = collectionInfo;     // direct array
      } else if (typeof collectionInfo === "object") {
        items = Object.entries(collectionInfo);                  
      } else {
        console.warn("collectionInfo is neither array nor object");
        return;
      }

      this.mainwapper.innerHTML = "";    
        let index = 0;          
      for (let item of items) {
        let handle;            
        if (Array.isArray(collectionInfo)) {
          handle = item;
        } else {
          handle = item[1];  // object case value
        }
        
        const cardEl = await cardProduct(handle); 
         const inputElements = cardEl?.querySelector('.variant-checkbox.cust_btn_select.is_multi_selected_acc') || null;
        if(inputElements != null) inputElements.type = "radio";   
        if(inputElements != null) inputElements.onchange = null;          // remove JS property
        inputElements?.removeAttribute('onchange'); 
        inputElements?.setAttribute('onchange', 'Stapthreeredio(this);');
        inputElements?.setAttribute('next_step_button', 'true');        

        const inputElements_popup = cardEl?.querySelector('.popup_data input.variant-radio') || null;
        if(inputElements_popup != null) inputElements_popup.type = "radio";   
        if(inputElements_popup != null) inputElements_popup.onchange = null;         
        inputElements_popup?.removeAttribute('onchange'); 
        inputElements_popup?.setAttribute('onchange', 'Stapthreeredio(this);');
        inputElements_popup?.setAttribute('next_step_button', 'true');

        cardEl?.querySelector(".qty_select_info_wrapp")?.remove();


        if (!cardEl) continue;
        const productId = cardEl.getAttribute("data-product-id");
        const wrapper = document.createElement("div");
        wrapper.className = `grid__item filters-${this.collection_name} `;
        wrapper.id = `filters-${this.collection_name}-${productId}`;
        wrapper.appendChild(cardEl);
        this.mainwapper.appendChild(wrapper);        
        index++; 
      }        
  } 
}

if (!customElements.get('tab-with-product-filter')) {
  customElements.define('tab-with-product-filter', tabWithProductFilter, { extends: 'div' } );
}